import { combineReducers } from "redux";
import customizerReducer from "../slices/customizer";

export default combineReducers({
  customizer: customizerReducer,
});
